(ns machtfit.dashboard.stepchall.form.duration
  (:require [clojure.string :as str]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.datetime :as datetime]
            [machtfit.human :as human]
            [machtfit.translation :refer [t]]
            [re-frame.core :as rf]))

(defn section-duration []
  (let [team-building-start @(rf/subscribe [:get [:challenge :team-building-start]])
        challenge-start @(rf/subscribe [:get [:challenge :challenge-start]])
        challenge-end @(rf/subscribe [:get [:challenge :challenge-end]])
        goal @(rf/subscribe [:get [:challenge :config :goal]])
        num-days (when (and (-> challenge-start str/blank? not)
                            (-> challenge-end str/blank? not))
                   (inc (human/days-from-to (-> challenge-start
                                                datetime/date-string->iso-date
                                                datetime/iso-date->date)
                                            (-> challenge-end
                                                datetime/date-string->iso-date
                                                datetime/iso-date->date))))
        steps-per-day (when (and (pos? num-days)
                                 (pos? goal))
                        (int (/ goal num-days)))

        main-unit-plural (t @(rf/subscribe [:get [:challenge :config :main-unit :plural]]))]
    [widgets/section
     {:anchor "duration"
      :title "Dauer"
      :content [:div
                [:div.col.s7
                 [widgets/date-input
                  {:value team-building-start
                   :on-save #(rf/dispatch [:set-path [:challenge :team-building-start] %])
                   :label-text "Teambildungsbeginn"
                   :required? true}]
                 [widgets/date-input
                  {:value challenge-start
                   :on-save #(rf/dispatch [:set-path [:challenge :challenge-start] %])
                   :label-text "Wettbewerbsbeginn"
                   :required? true}]
                 [widgets/date-input
                  {:value challenge-end
                   :on-save #(rf/dispatch [:set-path [:challenge :challenge-end] %])
                   :label-text "Wettbewerbsende"
                   :required? true}]]
                [:div.col.s5
                 [:div
                  "Anzahl Tage: " num-days]
                 [:div
                  (str (if-not (empty? main-unit-plural)
                         main-unit-plural
                         "Unit")
                       " pro Tag: ")
                  steps-per-day]]]}]))

